import { FacebookLogo, TwitterLogo, YouTubeLogo } from '@m/alchemy-ui';
import React, { useContext } from 'react';
import { CommunityContext } from '../../../context/Community';
import { useIsMobile } from '../../../hooks';
import * as Styled from '../Navigation.styled';

export const SocialMediaMenu = () => {
  const community = useContext(CommunityContext);
  const isMobile = useIsMobile();

  const size = isMobile ? '15' : '24';

  return (
    <>
      {community?.options?.twitterAllowFollow && (
        <Styled.SocialButtonWrapper>
          <a
            data-testid="twitterLink"
            href={`https://twitter.com/${community?.options?.twitterName || ''}`}
            target="_blank"
          >
            <TwitterLogo size={size} aria-label="Twitter" />
          </a>
        </Styled.SocialButtonWrapper>
      )}
      {community?.options?.facebookAllowFollow && (
        <Styled.SocialButtonWrapper>
          <a
            data-testid="facebookLink"
            href={`https://facebook.com/${community?.options?.facebookName || ''}`}
            target="_blank"
          >
            <FacebookLogo size={size} aria-label="Facebook" />
          </a>
        </Styled.SocialButtonWrapper>
      )}
      {community?.options?.youtubeAllowFollow && (
        <Styled.SocialButtonWrapper>
          <a
            data-testid="youtubeLink"
            href={`https://youtube.com/${community?.options?.youtubeName || ''}`}
            target="_blank"
          >
            <YouTubeLogo size={size} aria-label="Youtube" />
          </a>
        </Styled.SocialButtonWrapper>
      )}
    </>
  );
};
